<template>
  <div>
    <button class="btn btn-primary btn-block btn-download" type="button" @click="seconds" :disabled="time">
      <span v-if="time" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span v-if="time">&nbsp;Download game at: {{ time | twoNumbers }}</span>
      <span v-else>Download</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "download",
  props: ["slug"],
  data() {
    return {
      time: null,
      interval: null
    };
  },
  methods: {
    downloadRom() {
      this.time = null;
      clearInterval(this.interval);
    },
    seconds() {
      console.log(this.slug);
      this.getFile(this.slug);
      clearInterval(this.interval);
      this.time = 10;
      this.interval = setInterval(this.decrementTime, 1000);
    },
    decrementTime() {
      this.time = parseInt(this.time) - 1;
      if (this.time === 0) {
        this.downloadRom();
      }
    },
    getFile(slug) {
      window.location = `${process.env.API}post/${slug}/download`;
    }
  },
  filters: {
    twoNumbers(value) {
      return value.toString().length == 1 ? `0${value}` : value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Download.vue